import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c8c7fe48")

_pushScopeId("data-v-c8c7fe48")
const _hoisted_1 = { class: "center title-1" }
const _hoisted_2 = { class: "buttons" }
const _hoisted_3 = { class: "center title-1" }
const _hoisted_4 = { class: "users" }
const _hoisted_5 = {
  key: 0,
  class: "loader-container"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("dig-ui-loader", null, null, -1)
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "pagination-container" }
const _hoisted_9 = { class: "pagination-container" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createVNode("dig-ui-title", { class: "title-3 center" }, " Aucun utilisateur disponible ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_user_form = _resolveComponent("user-form")
  const _component_base_card = _resolveComponent("base-card")
  const _component_user_small_card = _resolveComponent("user-small-card")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("dig-ui-title", _hoisted_1, _toDisplayString($setup.t('users')), 1),
    _createVNode("div", _hoisted_2, [
      _createVNode("dig-ui-standard-button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.toggleAdding()))
      }, _toDisplayString($setup.t('addUser')), 1)
    ]),
    ($setup.adding)
      ? (_openBlock(), _createBlock(_component_base_card, { key: 0 }, {
          default: _withId(() => [
            _createVNode("dig-ui-title", _hoisted_3, _toDisplayString($setup.t('addUser')), 1),
            _createVNode(_component_user_form, {
              loading: $setup.loadingForm,
              creation: true,
              onValidate: _cache[2] || (_cache[2] = ($event: any) => ($setup.addUser($event))),
              onCancel: _cache[3] || (_cache[3] = ($event: any) => ($setup.toggleAdding()))
            }, null, 8, ["loading"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_4, [
      ($setup.loading && !$setup.users.length)
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            _hoisted_6
          ]))
        : _createCommentVNode("", true),
      (!$setup.loading || $setup.users.length)
        ? (_openBlock(), _createBlock("div", _hoisted_7, [
            _createVNode("dig-input-text", {
              onInput: _cache[4] || (_cache[4] = ($event: any) => ($setup.search($event.target.value))),
              hint: $setup.t('filterUserHint')
            }, _toDisplayString($setup.t('filterUser')), 41, ["hint"]),
            _createVNode("div", _hoisted_8, [
              ($setup.users.length > $setup.elementsPerPage)
                ? (_openBlock(), _createBlock("dig-ui-pagination", {
                    key: 0,
                    pageCount: Math.ceil($setup.users.length / $setup.elementsPerPage),
                    onChange: _cache[5] || (_cache[5] = ($event: any) => ($setup.currentPage = $event.detail)),
                    currentPage: $setup.currentPage,
                    "previous-text": "Prec",
                    "next-text": "Suiv"
                  }, null, 40, ["pageCount", "currentPage"]))
                : _createCommentVNode("", true)
            ]),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.users.filter(
          (s, i) =>
            i >= ($setup.currentPage - 1) * $setup.elementsPerPage &&
            i < $setup.currentPage * $setup.elementsPerPage,
        ), (user) => {
              return (_openBlock(), _createBlock(_component_user_small_card, {
                key: user.id,
                user: user,
                onDelete: _cache[6] || (_cache[6] = ($event: any) => ($setup.deleteUser($event)))
              }, null, 8, ["user"]))
            }), 128)),
            _createVNode("div", _hoisted_9, [
              ($setup.users.length > $setup.elementsPerPage)
                ? (_openBlock(), _createBlock("dig-ui-pagination", {
                    key: 0,
                    pageCount: Math.ceil($setup.users.length / $setup.elementsPerPage),
                    onChange: _cache[7] || (_cache[7] = ($event: any) => ($setup.currentPage = $event.detail)),
                    currentPage: $setup.currentPage,
                    "previous-text": "Prec",
                    "next-text": "Suiv"
                  }, null, 40, ["pageCount", "currentPage"]))
                : _createCommentVNode("", true)
            ]),
            (!$setup.users.length)
              ? (_openBlock(), _createBlock("div", _hoisted_10, [
                  _hoisted_11
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
})